<div
  class="global-form-error"
  *ngFor="let errorKey of errorKeys"
  [hidden]="!shouldShowError(errorKey)"
>
  <mat-icon color="warn">error</mat-icon>
  {{ validationMessages[errorKey] | translate }}
</div>
